import { Pipe, PipeTransform } from '@angular/core';

import { DsModalTheme } from '@design-system/ds-base-modal/types/ds-modal-theme.type';

@Pipe({
  name: 'dsBaseModalIcon',
  standalone: true,
})
export class DsBaseModalIconPipe implements PipeTransform {
  transform(theme: DsModalTheme | null | undefined): string {
    switch (theme) {
      case 'error':
        return 'error';
      case 'warning':
        return 'warning';
      case 'info':
        return 'help';
      case 'success':
      default:
        return 'task_alt';
    }
  }
}
